// Imports => Constants
import { KEYS } from '@opp/ui-kit';
import { ROUTES } from '@constants';

// Imports => Utilities
import { AcIsSet } from '@opp/ui-kit';

const GetRoute = (type) => {
  let result = null;

  switch (type) {
  case KEYS.TRANSACTION:
    result = ROUTES.TRANSACTION_DETAILS.path;
    break;

  case KEYS.MOVEMENT:
    result = ROUTES.MOVEMENT_DETAILS.path;
    break;

  case KEYS.WITHDRAWAL:
    result = ROUTES.WITHDRAWAL_DETAILS.path;
    break;

  case KEYS.PURCHASE:
    result = ROUTES.PURCHASE_DETAILS.path;
    break;

  case KEYS.SETTLEMENT:
    result = ROUTES.SETTLEMENT_DETAILS.path;
    break;

  default:
  }

  return result;
};

export const AcFormatInternalURI = (link, config) => {
  if (!AcIsSet(link)) return null;
  if (!AcIsSet(config) || !AcIsSet(config.type)) return null;

  let route = GetRoute(config.type);
  let field = (config && config.field) || 'id';

  if (AcIsSet(route)) route = route.replace(':id', link[field]);

  return route;
};
